import './Tweet.css';

const Avatar = ({src}) => <img className="user-avatar" src={src} alt="avatar" />
const User = ({name, handle}) => (<div className='user-wrap'><span>{name}</span> <span>{handle}</span></div>)
const Message = ({message}) => (<div className='user-msg'><p>{message}</p></div>)
 

const Tweet = ({name, handle, profile_image, message, score}) => {
    const smiley = '😀';
    const neutal = '😐';
    const frown = '😞';

    return (
        <div className="tweet-wrap">
            <div className='tweet-header'>
                <Avatar src={profile_image}/>
                <User name={name} handle={handle}/>
            </div>
            <Message message={message}/>
            <hr/>
        </div>
    );
  }
  
  export default Tweet;